import { get } from '@/libs/api.request'

export const getFeeTypes = () => {
  return get('/fee-types')
}
